import styled from "styled-components";
import { Dialog } from "@mui/material";
import Button from "../Button";
import { device } from "../../utils/device";

export const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    border-radius: 10px;
    width: 55vw;
    max-width: 90vw;
    max-height: 90vh;
    background-color: #ffffff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    z-index: 1000001 !important;
  }
  z-index: 1000001 !important;

  @media (max-width: 960px) {
    & .MuiDialog-paper {
      width: 90vw;
      margin: 10px;
    }
  }
`;

export const DialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  min-height: 40px;
  flex-shrink: 0;

  @media ${device.sm} {
    display: none;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.span`
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  /* DL-030: design-system ink #123051 (was #0f0f0f near-black). */
  color: #123051;
`;

export const CloseButton = styled.div`
  cursor: pointer;
`;

export const Separator = styled.div`
  height: 0;
  border: 1px solid #e1e1e1;
  width: 100%;
  flex-shrink: 0;
`;

export const ScrollableContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 0 32px;
`;

export const CardsContainer = styled.div`
  display: flex;
  align-items: stretch;

  gap: 16px;
  margin: 24px 0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const ChevronContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    transform: rotate(90deg);
    margin: -16px 0;
  }
`;

export const MiddleContentContainer = styled.div``;

export const WarningContainer = styled.div`
  margin: 16px 0;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;
  margin: 0;
  flex-shrink: 0;
  border-top: 1px solid #e1e1e1;

  @media (max-width: 768px) {
    padding: 16px;
    padding-bottom: 40px;
    gap:4px;
  }

  @media (max-width: 480px) {
    flex-direction: column-reverse;
    align-items: stretch;
    padding-bottom: 48px;
    gap:4px;
  }
`;

export const CancelText = styled.span`
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #495057;
  cursor: pointer;
  padding: 8px 12px;

  @media (max-width: 480px) {
    text-align: center;
    margin-top: 8px;
  }
`;

export const ActionButton = styled(Button)`
  width: auto !important;

  @media (max-width: 480px) {
    width: 100% !important;
  }
`;
